require('./submit-application-form');
require('./submit-form');

require('./vue-components/BookArrangementOrHall/app');

// WOW animated
const wow = new WOW({
    boxClass:     'wow', // default
    animateClass: 'animated', // default
    offset:       0, // default
    mobile:       true, // default
    live:         true // default
});
wow.init();

window.onload = function() {
    //Facilities carousel
    if($('.carouselFacilities').length > 0) {
        var $imagesCarousel = $('.carouselFacilities').flickity({
            // options
            contain:    true,
            autoPlay:   false,
            wrapAround: true,
            pageDots:   false,
            groupCells: 1,
            friction:   0.4
        });

        function resizeCells() {

            var flkty    = $imagesCarousel.data('flickity');
            var $current = flkty.selectedIndex
            var $length  = flkty.cells.length
            if($length <= '5') {
                $imagesCarousel.flickity('destroy');
            }
            $('.carouselFacilities .carouselImage').removeClass("nextToSelected");
            $('.carouselFacilities .carouselImage').eq($current - 1).addClass("nextToSelected");
            if($current + 1 == $length) {
                var $endCell = "0"
            } else {
                var $endCell = $current + 1
            }
            $('.carouselFacilities .carouselImage').eq($endCell).addClass("nextToSelected");
        };

        resizeCells();

        $imagesCarousel.on('scroll.flickity', function() {
            resizeCells();
        });
    }
};

if(document.querySelector(".arrangement-carousel")) {
    var elem  = document.querySelector('.arrangement-carousel');
    var flkty = new Flickity(elem, {
        cellAlign:      'left',
        adaptiveHeight: true,
        pageDots:       false,
        initialIndex:   0
    });
}

//This is a pen based off of Codewoofy's eyes follow mouse. It is just cleaned up, face removed, and then made to be a little more cartoony. https://codepen.io/Codewoofy/pen/VeBJEP

$("body").mousemove(function(event) {
    if($('.eye').length > 0) {
        var eye = $(".eye");
        var x   = (eye.offset().left) + (eye.width() / 2);
        var y   = (eye.offset().top) + (eye.height() / 2);
        var rad = Math.atan2(event.pageX - x, event.pageY - y);
        var rot = (rad * (180 / Math.PI) * -1) + 180;
        eye.css({
            '-webkit-transform': 'rotate(' + rot + 'deg)',
            '-moz-transform':    'rotate(' + rot + 'deg)',
            '-ms-transform':     'rotate(' + rot + 'deg)',
            'transform':         'rotate(' + rot + 'deg)'
        });
    }
});


if($('#TommyBookingSupport[data-widget="boeken"]').length > 0) {
    setInterval(function() {
        if($('.tbs-glyphicon.tbs-glyphicon-ice-lolly-tasted').length > 0) {
            $('.tbs-glyphicon.tbs-glyphicon-ice-lolly-tasted').removeClass('tbs-glyphicon tbs-glyphicon-ice-lolly-tasted fa-spin').addClass('fas fa-campground color-yellow fa-beat');
        }

        if($('.tbs_kassabon').length > 0 && !$('.tbs_kassabon').hasClass('tbs_kassabon_show')) {
            $('.tbs_kassabon').addClass('tbs_kassabon_show');
        }

        if($('.tbs_kassabon_toggle').length > 0) {
            $('.tbs_kassabon_toggle').remove();
        }
    }, 10);
}

if($('.visit-veluwe-iframe').length > 0) {
    $('.visit-veluwe-iframe').on('load', function() {
        if(typeof $(this).data('title') !== 'undefined') {
            $(this).contents().find('.header__title').text($(this).data('title'));
        }

        if(typeof $(this).data('subtitle') !== 'undefined') {
            $(this).contents().find('.header__subtitle').text($(this).data('subtitle'));
        } else {
            $(this).contents().find('.header__subtitle').text('In de omgeving van de Veluwe');
        }

        $(this).contents().find('.content__item__overview-link-wrapper').remove();

        /*$(this).contents().find('.content__item--link').click(function(e) {
            e.preventDefault();
        });*/

        var style = '<style>html, body { overflow-x: hidden; }</style>';
        $(this).contents().find('head').append(style);

        $(this).style({overflow: 'hidden'});

        $(this).contents().find('body').addClass($(this).parents('section').attr('class'));

        calculateIFrameSize();
    });

    $(window).resize(function() {
        calculateIFrameSize();
    });

    function calculateIFrameSize() {
        $('.visit-veluwe-iframe').each(function() {
            var headerHeight  = $(this).contents().find('header').height();
            var sectionHeight = $(this).contents().find('section.content').height();

            $(this).height(headerHeight + sectionHeight);
        });
    }
}

$(document).ready(function() {

    if($('[data-target="#packagesModal"]').length > 0) {
        $('[data-target="#packagesModal"]').click(function() {
            $('.accommodation-overview-modal .modal-title').text('Beschikbare arrangementen voor ' + $(this).data('title'));
            $('.arrangements-body').html('<tr><td colspan="5" class="text-center"><div class="spinner-grow color-primary" role="status"><span class="sr-only">laden...</span></div><div class="spinner-grow color-blue" role="status"> <span class="sr-only">laden...</span></div><div class="spinner-grow color-yellow" role="status"><span class="sr-only">laden...</span></div><div class="spinner-grow color-green" role="status"><span class="sr-only">laden...</span></div><div class="spinner-grow color-dark" role="status"><span class="sr-only">laden...</span></div></td></tr>');

            var $link = $(this).siblings('a');

            axios.get('/api/get-arrangements/' + $(this).data('id'))
                .then(function(response) {
                    var html = '';

                    for(var i in response.data) {
                        html += '<tr>';
                        html += '<td data-label="Arrangement">' + response.data[i].title + '</td>';
                        html += '<td data-label="Start datum">' + response.data[i].start_date_pretty + '</td>';
                        html += '<td data-label="Eind datum">' + response.data[i].end_date_pretty + '</td>';
                        html += '<td data-label="Prijs">' + response.data[i].price_pretty + '</td>';
                        html += '<td class="text-right"><a class="btn btn-sm btn-blue mb0" href="' + $link.attr('href').replace(/#.*$/, '') + '/' + response.data[i].tommy_id + '/boeken">Boeken</a></td>';
                        html += '</tr>';
                    }

                    $('.arrangements-body').html(html);
                })
        });
    }

    // initialize Tooltips
    $('[data-toggle="tooltip"]').tooltip();

    // Trigger datepicker on div
    $('#datepicker-trigger-start').click(function(e) {
        e.preventDefault();

        setTimeout(function() {
            $("#datepicker-start").click();
        }, 0);
    });
    $('#datepicker-trigger-end').click(function(e) {
        e.preventDefault();

        setTimeout(function() {
            $("#datepicker-end").click();
        }, 0);
    });

    // Autostop Youtube video on closing modal
    $('#youtubeVideo').on('hidden.bs.modal', function() {
        var $this   = $(this).find('iframe'),
            tempSrc = $this.attr('src');
        $this.attr('src', "");
        $this.attr('src', tempSrc);
    });

    if($('.dropdown-persons').length > 0) {
        $('.dropdown-persons').on('show.bs.dropdown', function() {
            showBackdrop();
        });

        $('.dropdown-persons').on('hide.bs.dropdown', function() {
            hideBackdrop();
        });
    }

    if($('[data-accommodation-group-id].active').length > 0) {
        var picker = new Litepicker({
            element:         document.getElementById('datepicker-start'),
            elementEnd:      document.getElementById('datepicker-end'),
            numberOfMonths:  2,
            numberOfColumns: 2,
            lang:            'nl-NL',
            minDate:         new Date(),
            maxDate:         new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
            singleMode:      false,
            hotelMode:       true,
            allowRepick:     false,
            autoApply:       true,
            //format:            'DD-MM-YYYY',
            lockDaysFormat: 'DD-MM-YYYY',
            tooltipText:    {
                one:   'nacht',
                other: 'nachten'
            },
            // The following function is added to the litepicker plugin and is very important. It basically rewrites the complete date-picking experience.
            onSelectFirstDate: function(date) {
                var availability = sessionStorage.getItem('availability-calendar');
                if(availability !== '') {
                    getAndLoadAvailability($('[data-accommodation-group-id].active').attr('data-accommodation-group-id'));
                }
                availability = JSON.parse(availability);

                if(typeof availability.availableDates !== 'undefined') {
                    date = new moment(date).format('DD-MM-YYYY');
                    for(i in availability.availableDates) {
                        if(availability.availableDates[i].date === date) {
                            this.options.minDays = (availability.availableDates[i].minDays !== false) ? availability.availableDates[i].minDays : null;
                            this.options.maxDays = (availability.availableDates[i].maxDays !== false) ? availability.availableDates[i].maxDays : null;

                            break;
                        }
                    }
                }

                if(this.triggerElement.id === 'datepicker-start') {
                    var minDays    = (this.options.minDays !== null) ? this.options.minDays : 1;
                    var secondDate = new moment(this.datePicked[0]).add(minDays, 'd');
                    this.setDateRange(this.datePicked[0], secondDate);
                    this.hide();

                    // Check for mobile mode.
                    if(this.picker.style.position != 'fixed') {
                        $("#datepicker-end").click();
                    }
                } else {
                    this.setDateRange(this.getStartDate(), this.datePicked[1]);
                    this.hide();
                }
            },
            onShow:            function() {
                showBackdrop();
                var availability = sessionStorage.getItem('availability-calendar');
                if(availability !== '') {
                    getAndLoadAvailability($('[data-accommodation-group-id].active').attr('data-accommodation-group-id'));
                }
                availability = JSON.parse(availability);

                if(typeof availability.unavailableDates !== 'undefined') {
                    this.setLockDays(availability.unavailableDates);
                }

                // Hack to get the triggerElement.
                var that = this;
                setTimeout(function() {
                    if(that.triggerElement.id === 'datepicker-end') {
                        if(that.getStartDate() !== null) {
                            that.datePicked[0] = that.getStartDate();
                        }
                    }
                }, 1);
            },
            onSelect:          function(start, end) {
                start         = new moment(start);
                end           = new moment(end);
                var startDate = '<span>Aankomst ' + (start ? start.locale('nl').format('D MMMM YYYY') : '') + '</span>';
                var endDate   = '<span>Vertrek ' + (end ? end.locale('nl').format('D MMMM YYYY') : '...') + '</span>';

                document.getElementById('datepicker-trigger-start').innerHTML = startDate;
                document.getElementById('datepicker-trigger-end').innerHTML   = endDate;
            },
            onHide:            function() {
                hideBackdrop();
            }
        });

        getAndLoadAvailability($('[data-accommodation-group-id].active').attr('data-accommodation-group-id'), picker);

        if($('[name="startDate"]').val() !== '' && $('[name="endDate"]').val() !== '') {
            var startDate = $('[name="startDate"]').val();
            var endDate   = $('[name="endDate"]').val();

            startDate = new Date(startDate);
            endDate   = new Date(endDate);

            picker.setDateRange(startDate, endDate);
        }
    }

    $('[data-accommodation-group-id]').click(function() {
        if(!$(this).hasClass('active')) {
            getAndLoadAvailability($(this).attr('data-accommodation-group-id'), picker);
            picker.setDateRange(null, null);
        }
    });

    renamePersonCategoriesButton();

    $('.person-categories').change(function(e) {
        renamePersonCategoriesButton();
    });
});

function renamePersonCategoriesButton() {
    var amount = 0;

    $('.person-categories').each(function() {
        amount += parseInt($(this).val());
    });

    $('.button-person-categories').text(amount + ' personen');
}

function getAndLoadAvailability(groupId, picker = null) {
    $('[name="accommodationGroup"]').val(groupId);
    axios.get('/api/get-availability/' + groupId)
        .then(function(response) {
            sessionStorage.setItem('availability-calendar', JSON.stringify(response.data));

            if(picker !== null && picker.getStartDate() === null && picker.getEndDate() === null) {
                var date    = response.data.availableDates[0].date.split('-');
                date        = new moment(date[2] + '-' + date[1] + '-' + date[0]);
                var minDays = response.data.availableDates[0].minDays !== false ? response.data.availableDates[0].minDays : 1;
                var date1   = new Date(date);
                date.add(minDays, 'd');
                var date2 = new Date(date);

                picker.setDateRange(date1, date2);
            }
        });
}

function showBackdrop() {
    if($('.search-and-book-backdrop').length === 0) {
        $('<div class="search-and-book-backdrop" style="background:rgba(0,0,0,0.7); z-index:99; position:fixed; top:0; bottom:0; left:0; right:0;"></div>').insertBefore('.search-book-container');
        $('.search-and-book-backdrop').click(function() {
            hideBackdrop();
        });
    }
}

function hideBackdrop() {
    $('.search-and-book-backdrop').unbind('click');
    $('.search-and-book-backdrop').remove();
}

(function($) {
    "use strict"; // Start of use strict

    // Append .background-image-holder <img>'s as CSS backgrounds
    $('.background-image-holder').each(function() {
        var imgSrc = $(this).children('img').attr('src');
        $(this).css('background', 'url("' + imgSrc + '")');
        $(this).children('img').hide();
        $(this).css('background-position', 'initial');
    });

    // MAP
    $('.map-holder').click(function() {
        $(this).addClass('interact');
    });

    if($('.map-holder').length) {
        $(window).scroll(function() {
            if($('.map-holder.interact').length) {
                $('.map-holder.interact').removeClass('interact');
            }
        });
    }

    // Input field counter plus minus
    $('.input-counter-minus').click(function() {
        var $input = $(this).parent().find('input');
        var count  = parseInt($input.val()) - 1;
        count      = count < 1 ? 0 : count;
        $input.val(count);
        $input.change();
        return false;
    });
    $('.input-counter-plus').click(function() {
        var $input = $(this).parent().find('input');
        $input.val(parseInt($input.val()) + 1);
        $input.change();
        return false;
    });

    // Mouse parallax
    var rect  = $('section')[0].getBoundingClientRect();
    var mouse = {
        x:     0,
        y:     0,
        moved: false
    };

    $("section").mousemove(function(e) {
        mouse.moved = true;
        mouse.x     = e.clientX - rect.left;
        mouse.y     = e.clientY - rect.top;
    });

    // Ticker event will be called on every frame
    TweenLite.ticker.addEventListener('tick', function() {
        if(mouse.moved) {
            parallaxIt(".mouse-move", -10);
            parallaxIt(".fox-home", -20);
            parallaxIt(".lines", 4);
        }
        mouse.moved = false;
    });

    function parallaxIt(target, movement) {
        TweenMax.to(target, 0.4, {
            x: (mouse.x - rect.width / 2) / rect.width * movement,
            y: (mouse.y - rect.height / 2) / rect.height * movement
        });
    }

    $(window).on('resize scroll', function() {
        rect = $('section')[0].getBoundingClientRect();
    })

    // ACCORDION
    $("#accordion").on("hide.bs.collapse show.bs.collapse", e => {
        $(e.target).prev().find("i:last-child").toggleClass("fa-minus fa-plus");
    });

    $("#accordion").on("shown.bs.collapse", e => {
        $("html, body").animate({
                scrollTop: $(e.target).prev().offset().top - 100
            },
            300);
    });

    // Gridzy
    $('.gridzy').gridzy({
        spaceBetween:  12,
        desiredHeight: 350
    });

    // Modulobox
    var modulobox = new ModuloBox({
        mediaSelector:      '.gallery figure > a, .hidden-gallery div',
        loop:               3,
        history:            true,
        controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
        shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
        videoMaxWidth:      1440,
        minZoom:            1,
        zoomTo:             1.8,
        mouseWheel:         false,
        contextMenu:        false,
        scrollToZoom:       true,
        captionSmallDevice: false,
        thumbnails:         true,
        thumbnailsNav:      'centered',
        thumbnailSizes:     {
            1920: {
                width:  110,
                height: 80,
                gutter: 10
            },
            1280: {
                width:  90,
                height: 65,
                gutter: 10
            },
            680:  {
                width:  0,
                height: 0,
                gutter: 0
            }
        }
    });

    modulobox.on('beforeOpen.modulobox', function(gallery, index) {

        if(window.cubeRAF) {

            cancelAnimationFrame(window.cubeRAF);
            window.cubeRAF = false;

        }

    });

    modulobox.on('afterClose.modulobox', function(gallery, index) {

        if(typeof Event === 'function' && !window.cubeRAF) {
            window.dispatchEvent(new Event('scroll'));
        }

    });

    modulobox.init();

    // Smooth scrolling using jQuery easing
    $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
        if(location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
            var target = $(this.hash);
            target     = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if(target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 150
                }, 1000, "easeInOutExpo");
                return false;
            }
        }
    });

    // Parallax header
    $(function() {
        // 	init scrollmagic
        var controller = new ScrollMagic.Controller();

        //  HEADER BACKGROUND IMAGE SCROLL
        $("section").each(function() {

            var bg = $(this).find(".parallax");

            // Add tweenmax for backgroundParallax
            var parallax = TweenMax.from(bg, 1, {
                y:    '-20%',
                ease: Power0.easeNone
            });

            // Create scrollmagic scene
            var parallaxScene = new ScrollMagic.Scene({
                triggerElement: this, // <-- Use this to select current element
                triggerHook:    1,
                duration:       '150%',
            })
                .setTween(parallax)
                .addTo(controller);
        });
    });

})(jQuery); // End of use strict

if(document.querySelector("#scroll-indicator")) {
    $(document).ready(function() {
        // Closes responsive menu when a scroll trigger link is clicked
        $('.js-scroll-trigger').click(function() {
            $('.navbar-collapse').collapse('hide');
        });

        // Collapse Navbar
        var navbarCollapse = function() {
            if($("#scroll-indicator").offset().top > 100) {
                $("#mainNav").addClass("navbar-shrink");
            } else {
                $("#mainNav").removeClass("navbar-shrink");
            }
        };

        // Collapse now if page is not at top
        navbarCollapse();
        // Collapse the navbar when page is scrolled
        $(window).scroll(navbarCollapse);
    });
}

if(document.querySelector('.celebrate-option-overview')) {
    function showOption(btn) {
        document.querySelector(".detail-img").src         = btn.dataset.image;
        document.querySelector(".option-title").innerHTML = btn.dataset.option
        document.querySelector(".option-text").innerHTML  = btn.dataset.text

        const showMoreBtn     = document.querySelector(".show-more-btn")
        showMoreBtn.innerHTML = `Bekijk ${btn.dataset.title}`
        showMoreBtn.href      = `${btn.dataset.url}`

        const tags = btn.dataset.tags.split(',');
        document.querySelectorAll(".room-tag").forEach((tag) => {
            tag.style.display = "none"
        });

        tags.forEach((tagOption) => {
            const tag = document.querySelector(`[data-room="${tagOption}"]`);
            if(tag) {
                tag.style.display = 'block';
            }
        });
    }

    showOption(document.querySelector('.btn.active'));

    if(document.querySelector(".celebrate-option-overview")) {
        document.querySelectorAll(".option-btn").forEach((btn) => {
            btn.addEventListener("click", () => {
                document.querySelector(".option-btn.active").classList.remove('active');
                btn.classList.add('active');
                showOption(btn);
            })
        })
    }
}